import { Link } from 'react-router-dom';
import { ArrowUpRight, Calendar, Clock } from 'lucide-react';

interface BlogCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImageUrl: string;
  category: string;
  authorName: string;
  publishedAt: string;
  readingTime: number;
}

export function BlogCard({ slug, title, excerpt, coverImageUrl, category, authorName, publishedAt, readingTime }: BlogCardProps) {
  const formattedDate = new Date(publishedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });

  return (
    <Link to={`/blog/${slug}`} className="group block h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bv-blue focus-visible:ring-offset-4">
      <article className="flex h-full flex-col overflow-hidden rounded-3xl border border-bv-blue-line bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-bv-window">
        <div className="relative aspect-[16/9] overflow-hidden bg-bv-blue-wash">
          <img src={coverImageUrl} alt={title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
          <span className="absolute right-4 top-4 flex h-9 w-9 translate-y-1 items-center justify-center rounded-full bg-white/90 text-bv-ink opacity-0 shadow-bv-card transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100"><ArrowUpRight className="h-4 w-4" /></span>
        </div>
        <div className="flex flex-1 flex-col p-6">
          {category && <span className="self-start rounded-full bg-bv-blue-wash px-3 py-1 text-xs font-semibold text-bv-blue">{category}</span>}
          <h3 className="mt-4 line-clamp-2 font-display text-xl font-semibold leading-snug text-bv-ink transition-colors group-hover:text-bv-blue">{title}</h3>
          <p className="mt-3 line-clamp-3 flex-1 text-[15px] leading-6 text-bv-ink2">{excerpt}</p>
          <div className="mt-5 flex items-center justify-between gap-3 border-t border-bv-blue-line pt-4 text-xs text-bv-mute">
            <span className="truncate font-semibold text-bv-ink2">{authorName}</span>
            <div className="flex shrink-0 items-center gap-3">
              <span className="flex items-center gap-1"><Calendar className="h-3 w-3" />{formattedDate}</span>
              <span className="flex items-center gap-1"><Clock className="h-3 w-3" />{readingTime} min</span>
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
}
